import { useTranslation } from "@repo/i18n";
import { css } from "@repo/styled-system/css";

/** RGAA skip-link: visually hidden until focused, then jumps keyboard users past the chrome to <main>. */
export function SkipLink() {
  const { t } = useTranslation();
  return (
    <a
      href="#main"
      className={css({
        position: "absolute",
        left: "2",
        top: "-40px",
        zIndex: "banner",
        bg: "bg.default",
        color: "accent.default",
        px: "3",
        py: "2",
        rounded: "md",
        _focus: { top: "2" },
      })}
    >
      {t("shell.skipToContent")}
    </a>
  );
}
